// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { Pais } from "../interfaces/Pais";

export const paisService = async () => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/pais`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        const paisesSystem = response.data.filter(
          (pais: Pais) => pais.origem === 0
        );
        return paisesSystem;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
